<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<h1 style="padding-bottom:20px;">Prologue</h1>
<p style="text-align: center;"><em>Thou shalt not bear false witness</em></p><br/><br/>
<p style="text-indent:0px;"><em>Dear Reader,</em></p>
<p style="text-indent:0px;"><em>I know that time is precious, but I have plenty of it for the foreseeable future. I will endeavour however, not to waste yours. There is not much to do here, so I finally have a chance to write a book – something I always thought I would get around to, but in much more pleasant circumstances than I find myself in currently.</em></p>
<p style="text-indent:0px;"><em>I have no laptop to work on, so I’m hoping I will be able to get hold of pen and paper at least. They say the pen is mightier than the sword, but right now I am not so sure about that.</em></p>
<p style="text-indent:0px;"><em>Anyway, it’s lights out soon, so I’ll let you and the judicial system (and possibly God) be the judge of who’s the real villain here.</em></p><br/>
<p style="text-indent:0px;"><em>E</em></p>
<p style="text-indent:0px;"><em>PS</em></p><br/>
<p><em>My cellmate is already getting on my nerves, just what I need another annoying woman in my life!</em></p>
<p style="text-indent:0px;"><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?6a152904